import React from "react";

import { getShortTitle, MenuType } from "utils/menuTypeUtils";

export const MenuTypeDisplay: React.FC<{ type: MenuType }> = ({ type }) => (
  <div className="px-md py-sm text-sm rounded bg-leafly-white text-black">
    {getShortTitle(type)} only
  </div>
);
